<template>
  <div class="org-list">
    <!-- 机构卡片 -->
    <div class="org-card-container">
      <el-card 
        class="org-card" 
        v-for="org in orgList" 
        :key="org.id" 
        :body-style="{padding: '0'}"
      >
        <div class="org-row">
          <div class="card-checkbox">
            <el-checkbox
              :value="selectedOrgIds.includes(org.id)"
              @change="toggleOrgSelection(org.id)"
            ></el-checkbox>
          </div>
          <div class="card-logo">
            <img :src="org.logoUrl" alt="logo" @error="org.logoUrl = '/static/logo.png'" />
            <div class="logo-label">{{ org.name }}</div>
          </div>
          <div class="card-info">
            <div class="info-item">
              <span class="info-label">ID</span>
              <span class="info-value">{{ org.id }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">教师人数</span>
              <span class="info-value">{{ org.teacherCount }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">学生人数</span>
              <span class="info-value">{{ org.studentCount }}</span>
            </div>
            <div class="info-item course-info-item">
  <span class="info-label">课程信息</span>
  <span class="info-value course-list">
    <template v-if="org.courseUrls && org.courseUrls.length">
      <span v-for="(course, idx) in org.courseUrls" :key="idx">&nbsp;&nbsp;{{ course }}</span>
    </template>
    <template v-else>
      暂无
    </template>
  </span>
</div>
          </div>
         
          <el-button
            class="delete-btn"
            :class="{ active: selectedOrgIds.includes(org.id) }"
            type="danger"
            icon="el-icon-delete"
            circle
            size="mini"
            :disabled="!selectedOrgIds.includes(org.id)"
            @click.stop="confirmDelete(org)"
          ></el-button>
        </div>
      </el-card>
    </div>
    
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      newOrg: { name: '' }, // 新机构名称
      rules: {
        name: [{ required: true, message: '机构名称不能为空', trigger: 'blur' }],
      },
      orgList: [], // 机构列表
      selectedOrg: null,
      detailsVisible: false,
      selectedOrgIds: [], // 多选支持
    };
  },
  created() {
    this.fetchOrgList(); // 获取机构列表
  },
  methods: {
    // 多选切换
    toggleOrgSelection(id) {
      const idx = this.selectedOrgIds.indexOf(id);
      if (idx > -1) {
        this.selectedOrgIds.splice(idx, 1);
      } else {
        this.selectedOrgIds.push(id);
      }
    },
    // 获取机构信息
    fetchOrgList() {
      const accountNum = localStorage.getItem('agentUserInfo').replace(/^"|"$/g, '');
      if (!accountNum) {
        this.$message.error('没有找到账号信息，请重新登录');
        return;
      }

      axios.get('/api/invitationTable/getInvitationName', { 
        params: { accountNum }
      }).then(response => {
        if (response.data.success) {
          const mergedDataList = response.data.data.mergedDataList;
          this.orgList = mergedDataList.map(org => ({
            id: org.id,
            name: org.institutionName,
            studentCount: org.studentCount,
            teacherCount: org.teacherCount,
            courseUrls: org.courseUrls || [],
            logoUrl: org.logoUrl || '/static/logo.png', // 新增
          }));
        } else {
          this.$message.error('获取机构信息失败');
        }
      }).catch(error => {
        this.$message.error('请求失败');
        console.error(error);
      });
    },
    // 获取机构详情
    showDetails(org) {
      this.selectedOrg = { ...org };
      this.detailsVisible = true;
    },
    // 隐藏机构详情框
    hideDetails() {
      this.selectedOrg = null;
      this.detailsVisible = false;
    },
    // 确认删除
    confirmDelete(org) {
      this.$confirm('确认删除该机构吗？删除后不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const index = this.orgList.findIndex(item => item.id === org.id)
        if (index > -1) {
          this.orgList.splice(index, 1);
          this.$message.success('删除成功');
        }
      }).catch(() => {});
    },
    // 查看完整课程信息
    showFullCourseInfo(courseUrls) {
      this.$alert(courseUrls.join(', '), '课程信息', {
        confirmButtonText: '关闭',
      });
    }
  },
};
</script>

<style scoped>
.org-card-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.org-card {
  background: #E2F3FF;
  border-radius: 12px;
  box-shadow: none;
  margin-bottom: 12px;
  padding: 0;
  position: relative;
}
.org-row {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 64px;
  padding: 8px 0 8px 8px;
  box-sizing: border-box;
}
.card-checkbox {
  width: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.card-checkbox .el-checkbox {
  /* border: 2px dashed #B3D8F6; */
  border-radius: 8px;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
}
.card-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #2EA2FA !important;
  background: #2EA2FA !important;
}
.card-logo {
  width: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 18px;
}
.card-logo img {
  width: 110px;
  height: 36px;
  margin-bottom: 2px;
}
.logo-label {
  font-size: 13px;
  color: #333;
  text-align: center;
  margin-top: 2px;
}
.card-info {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 40px;
}
.info-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 80px;
  font-size: 14px;
  color: #333;
  margin-right: 10px;
}
.info-label {
  font-weight: 500;
  color: #666;
  margin-bottom: 2px;
}
.info-value {
  font-size: 15px;
  color: #222;
}
.course-info-item {
  min-width: 240px;
  flex: 2;
}
.course-list {
  color: #666;
  font-size: 14px;
  word-break: break-all;
}
.card-upload {
  width: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: 12px;
}
.upload-icon {
  font-size: 22px;
  color: #C5C6C7;
  transition: color 0.2s;
}
.upload-icon.active {
  color: #FF4B4B;
}
.delete-btn {
  position: absolute;
  right: 0px;
  top: 0px;
  z-index: 2;
  border-radius: 1px !important;
  background: #AAAAAA !important;
  border: none !important;
  color: #AAAAAA !important;
  transition: background 0.2s, color 0.2s;
}
.delete-btn.active {
  width: 48px;
  background: #FF4B4B !important;
  color: #fff !important;
  color: #fff !important;
  cursor: pointer;
  font-size:20px;
  border-bottom-left-radius: 10px !important;
}
.delete-btn:disabled {
  width: 48px;
  opacity: 1;
  background: #AAAAAA !important;
  color: #fff !important;
  cursor: pointer;
  font-size:20px;
  border-bottom-left-radius: 10px !important;
}
</style>
